import { Directive, output } from '@angular/core';

@Directive({
  selector: '[tdWbSwipe]',
  exportAs: 'tdWbSwipe',
  host: {
    '(touchstart)': 'onSwipeStart($event)',
    '(touchend)': 'onSwipeEnd($event)'
  }
})
export class SideSheetSwipeDirective {

  readonly next = output<void>();
  readonly previous = output<void>();
  readonly up = output<void>();
  readonly down = output<void>();
  swipeCoordinates: Array<number> = [0, 0];
  swipeTime: number = new Date().getTime();

  onSwipeStart($event: TouchEvent): void {
    this.onSwipe($event, 'start');
  }

  onSwipeEnd($event: TouchEvent): void {
    this.onSwipe($event, 'end');
  }

  onSwipe(e: TouchEvent, when: string): void {
    this.swipe(e, when);
  }

  swipe(e: TouchEvent, when: string): void {

    const coordinates: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoordinates = coordinates;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coordinates[0] - this.swipeCoordinates[0], coordinates[1] - this.swipeCoordinates[1]];
      const duration = time - this.swipeTime;
      const fastEnough = duration < 1000;
      const longHorizontalEnough = Math.abs(direction[0]) > 30;
      const longVerticalEnough = Math.abs(direction[1]) > 30;
      const horizontalEnough = Math.abs(direction[0]) > Math.abs(direction[1] * 3);
      const verticalEnough = Math.abs(direction[1]) > Math.abs(direction[0] * 3);

      if (fastEnough && longHorizontalEnough && horizontalEnough) { // Horizontal enough
        const swipeHorizontalDir = direction[0] < 0 ? 'next' : 'previous';
        if (swipeHorizontalDir === 'next') {
          // TODO: The 'emit' function requires a mandatory void argument
          this.next.emit();
        } else {
          // TODO: The 'emit' function requires a mandatory void argument
          this.previous.emit();
        }
      } else if (fastEnough && longVerticalEnough && verticalEnough) {
        const swipeVerticalDir = direction[1] < 0 ? 'up' : 'down';
        if (swipeVerticalDir === 'up') {
          // TODO: The 'emit' function requires a mandatory void argument
          this.up.emit();
        } else {
          // TODO: The 'emit' function requires a mandatory void argument
          this.down.emit();
        }
      }
    }
  }
}
